export const isBooked = (seat, sessionUUID, selectedSeats) => {
  return (
    seat.status === 'occupied' || (seat.status === 'selected' && !isSelectedByMe(seat, sessionUUID) && !isSeatInBasket(seat, selectedSeats))
  )
}
export const isSelectedByMe = (seat, sessionUUID) => {
  return seat.status === 'selected' && seat.session_uuid === sessionUUID
}
export const isSeatInBasket = (seat, selectedSeats) => {
  return selectedSeats && selectedSeats.find((s) => s.id === seat.id)
}

export const hasSeatGaps = (selectedSeats, initialSeats) => {
  const rows = {}
  for (const seat of selectedSeats) {
    if (!rows[seat.row]) rows[seat.row] = []
    rows[seat.row].push(seat.seat)
  }

  const affectedRows = Object.keys(rows)
  if (affectedRows.length === 0) return false

  // Gap detection
  for (const row of Object.keys(rows)) {
    if (rows[row].length < 2) continue

    const minSeat = Math.min(...rows[row])
    const maxSeat = Math.max(...rows[row])

    const rowSeats = initialSeats.filter((s) => s.row === row)

    for (let i = minSeat; i <= maxSeat; i++) {
      const seatInRow = rowSeats.find((s) => s.seat === i)
      if (!seatInRow) continue
      if (!selectedSeats.some((s) => s.id === seatInRow.id)) {
        // Only consider available (non-occupied) seats as gaps
        if (seatInRow.status === 'available' && seatInRow.type !== 'empty') return true
      }
    }
  }

  // Isolation check — test only neighbors of selected seats
  // A neighbor is isolated if it's free and blocked on BOTH sides by occupied/selected seats
  for (const selected of selectedSeats) {
    const rowSeats = initialSeats.filter((s) => s.row === selected.row)

    // Check left and right neighbors
    for (const neighborSeat of [selected.seat - 1, selected.seat + 1]) {
      const neighbor = rowSeats.find((s) => s.seat === neighborSeat)
      if (!neighbor || neighbor.status !== 'available' || neighbor.type === 'empty') continue
      // Skip if this neighbor is itself a selected seat
      if (selectedSeats.some((s) => s.id === neighbor.id)) continue

      // Check if blocked on both sides by occupied/selected seats (not by row boundaries)
      const leftSeat = rowSeats.find((s) => s.seat === neighbor.seat - 1)
      const rightSeat = rowSeats.find((s) => s.seat === neighbor.seat + 1)

      const isLeftBlocked =
        leftSeat &&
        leftSeat.type !== 'empty' &&
        (leftSeat.status === 'occupied' || selectedSeats.some((s) => s.id === leftSeat.id) || leftSeat.status === 'selected')
      const isRightBlocked =
        rightSeat &&
        rightSeat.type !== 'empty' &&
        (rightSeat.status === 'occupied' || selectedSeats.some((s) => s.id === rightSeat.id) || rightSeat.status === 'selected')

      if (isLeftBlocked && isRightBlocked) {
        return true
      }
    }
  }

  return false
}
